import { Team } from "../../entities/Team";
import { httpClient } from "../http/httpClient";

export interface TeamGetResponse {
  teams: Team[];
  message?: string;
  pagination: {
    total: number;
    skip: number;
    limit: number;
    sort: string;
    order: string;
  };
}

export interface TeamGetParams {
  teamIds?: string;
  search?: string;
  limit?: number;
  skip?: number;
  sort?: string;
  order?: string;
  startDate?: string;
  endDate?: string;
}

export const getTeams = async (params?: TeamGetParams | undefined) => {
  const { data } = await httpClient.get<TeamGetResponse>("/team", {
    params,
  });

  return data;
};
